import { Datagrid, DateField, List, TextField } from "react-admin";

export const AwsBucketsList = props => (
    <List bulkActionButtons={false} {...props}>
        <Datagrid rowClick="edit">
            <TextField source="Name" />
            <DateField source="CreationDate" />
            <TextField source="id" />
        </Datagrid>
    </List>
);